import { TInputParams } from 'entries/common/widgets/context';
import { FieldValues } from 'react-hook-form';
import { ParametersEnum } from '../../types';
import { SHOULD_BE_MORE_THEN_ZERO } from '../const';
import { dimensionsErrors } from '../../const';

export const checkIsSumWrong = (data: FieldValues) => {
  if (!data.length) {
    return undefined;
  }
  const length = Number(data.length);
  const width = Number(data.width);
  const height = Number(data.height);
  const doorsResult = Number(data.doors) * 1.4;
  const windowsResult = data.windows ? Number(data.windows) * 2.73 : 0;
  const sum = (length + width) * 2 * height - doorsResult - windowsResult;

  return sum <= 0;
};

export const setIsAreaEnabledHandler = (
  filteredInputParams: TInputParams,
  setIsAreaEnabled: (valOrUpdater: boolean | ((currVal: boolean) => boolean)) => void
) => {
  if (filteredInputParams.includes(ParametersEnum.area) && filteredInputParams.length === 1) {
    setIsAreaEnabled(true);
  }
};

export const setShowWarningBarHandler = (
  hasNegativeParams: boolean | undefined,
  setShowWarningBar: (valOrUpdater: boolean | ((currVal: boolean) => boolean)) => void
) => {
  if (hasNegativeParams) {
    setShowWarningBar(true);
  } else {
    setShowWarningBar(false);
  }
};

export const getRoomParametersAreaText = (areaEnabledState: boolean): string =>
  areaEnabledState ? 'Указать количество' : 'Указать размеры';

export const getRoomParamsQuantity = (filteredInputParams: TInputParams) =>
  filteredInputParams.length > 3
    ? [
        { inputParameters: filteredInputParams.slice(0, 2), key: 'large_start' },
        { inputParameters: filteredInputParams.slice(2), key: 'large_end' },
      ]
    : [{ inputParameters: filteredInputParams, key: 'mobile' }];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const roomParametersValidation = async (inputValue: any, parameter: ParametersEnum) => {
  if (inputValue === '0') return SHOULD_BE_MORE_THEN_ZERO;
  if (!inputValue) return dimensionsErrors[parameter]?.required;
  return undefined;
};
